module.exports = __webpack_public_path__ + "img/andrew-thank-you-cta.3b82586f.png";